import { EcomPlatformViewerScriptContext } from '../../viewer-script/types';
import { getCartIconControllerConfig } from './internalOnlineStoresOnlyPublicApi.utils';

export function createInternalOnlineStoresOnlyPublicApi({
  context,
}: {
  context: EcomPlatformViewerScriptContext;
}) {
  const getCartIconCompIdAndExternalId = () => {
    const cartIconControllerConfig = getCartIconControllerConfig(context);
    if (!cartIconControllerConfig) {
      return null;
    }

    return {
      externalId: cartIconControllerConfig.config.externalId,
      compId: cartIconControllerConfig.compId,
    };
  };

  return {
    getCartIconCompIdAndExternalId,
  };
}
